var reviewsSliderSwiper = new Swiper('.reviews-slider', {
  slidesPerView: 1,
  spaceBetween: 20,
  autoplay: {
    delay: 8000,
    disableOnInteraction: false,
  },
  loop: true,
  cssMode: false,
  draggable: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
    enabled: true
  }
});
